import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidatePhoneNumberUserQuery } from './usePhoneNumberUserQuery';
import { invalidateZoomImportablePhoneNumbersQuery } from './useZoomImportablePhoneNumbersQuery';

export function useImportZoomPhoneNumberMutation({
	onSuccess,
	onError,
	onSettled,
}: {
	onSuccess?: (data: Api.ITelephonyConfiguration) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSettled?: () => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ phoneNumber }: { phoneNumber: string }) =>
			userSession.webServiceHelper.callAsync<Api.ITelephonyConfiguration>('PhoneNumber/zoom/import', 'POST', {
				phoneNumber,
			}),
		onError,
		onSuccess,
		onSettled: () => {
			invalidatePhoneNumberUserQuery();
			invalidateZoomImportablePhoneNumbersQuery();
			onSettled?.();
		},
	});
}
